export const general = {
  'general.error': 'Something went wrong, try again in a few moments...',
  'general.notice': 'Notice',
  'general.close': 'Close',
  'general.close.a11y-hint': 'Closes the modal',
  'general.cancel': 'Cancel',
  'general.back': 'Back',
  'general.remove': 'Remove',
  'general.submit': 'Submit',
  'general.submit-a11y-hint': 'Submits entered text',
  'general.clear': 'Clear',
  'general.clear-a11y-hint': 'Clears entered text',
  'general.connection-issue-message':
    'Aww, snap peas! Please try again. We’re having a connection issue.',
  'general.menu': 'Menu',
  'general.pickup': 'Pickup',
  'general.outpost': 'Outpost',
  'general.delivery': 'Delivery',
  'general.address-type': `{addressType, select,
    pickup {Pickup}
    outpost {Outpost}
    delivery {Delivery}
    other {Pickup}
  }`,
  'general.checkout': 'Checkout',
  'general.check-out': 'Check out',
  'general.go-back': 'Go back',
  'general.continue': 'Continue',
  'general.confirm': 'Confirm',
  'general.checkout.label.open': 'Open Bag',
  'general.checkout.label.close': 'Close Bag',
  'general.calories-short': 'cal',
  'general.your-order': 'Your order',
  'general.delivery-location': 'Delivery location',
  'general.outpost-location': 'Outpost location',
  'general.pickup-location': 'Pickup location',
  'general.delivery-tip': 'Delivery Tip',
  'general.delivery-notice':
    '100% goes to the courier. You cannot adjust tip after placing your order.',
  'general.update': 'Update',
  'general.unavailable': 'Unavailable',
  'general.review-your-pickup-order': 'Review your pickup order',
  'general.review-your-outpost-order': 'Review your Outpost order',
  'general.review-your-delivery-order': 'Review your delivery order',
  'general.share-favorite': 'Checkout out the {productName} at sweetgreen!',
  'general.subtotal-and-tax-label': 'Subtotal & tax',
  'general.subtotal-label': 'Subtotal',
  'general.tax-label': 'Tax',
  'general.estimated-tax-label': 'Estimated tax*',
  'general.service-fee-label': 'Service Fee',
  'general.delivery-fee-label': 'Delivery Fee',
  'general.credit-label': 'Credit',
  'general.reward-header': 'Choose your reward',
  'general.service-fee-description':
    '15% of your subtotal to help us source, staff & prep your unique order.',
  'general.total-label': 'Total',
  'general.estimated-total-label': 'Estimated total',
  'general.payment': 'Payment',
  'general.payment-method': 'Payment method',
  'general.extras': 'Extras',
  'general.resend': 'Resend',
  'general.apply': 'Apply',
  'general.and': 'and',
  'general.scrollTo': 'Scroll to {target}',
  'general.asap': 'ASAP',
  'general.asap-delivery': 'ASAP {start} - {end} MINS',
  'general.terms-of-use': 'terms of use',
  'general.privacy-policy': 'privacy policy',
  'general.month': 'Month',
  'general.day': 'Day',
  'general.today': 'today',
  'general.available-time-today': 'Today',
  'general.available-time': '{hours}:{minutes} {clock}',
  'general.available-start-time': '{hours}:{minutes}',
  'general.weekday.monday': 'Monday',
  'general.weekday.tuesday': 'Tuesday',
  'general.weekday.wednesday': 'Wednesday',
  'general.weekday.thursday': 'Thursday',
  'general.weekday.friday': 'Friday',
  'general.weekday.saturday': 'Saturday',
  'general.weekday.sunday': 'Sunday',
  'general.month.january': 'January',
  'general.month.february': 'February',
  'general.month.march': 'March',
  'general.month.april': 'April',
  'general.month.may': 'May',
  'general.month.june': 'June',
  'general.month.july': 'July',
  'general.month.august': 'August',
  'general.month.september': 'September',
  'general.month.october': 'October',
  'general.month.november': 'November',
  'general.month.december': 'December',
  'general.you': 'You',
  'general.custom': 'Custom',
  'general.custom-product-name': 'Custom {productName}',
  'general.terms-and-conditions': 'Terms and conditions',
  'general.see': 'See',
  'general.ends-on-date': 'Ends on {date}',
  'general.got-it': 'Got it',
  'general.maintenance-message':
    "Apologies, we're down for maintenance right now.",
  'general.maintenance-image.a11y': 'Maintenance mode illustration',
  'general.seasonal': 'Seasonal',
  'general.link-copy-message': 'Copied link',
};
